import apiFetch from '../apiFetch'

export default function (idSecuencia) {
  return apiFetch({endPoint: `Secuencia/getSecuencia?idSecuencia=` + idSecuencia, method: 'GET', body: null})
}